module.exports = __webpack_public_path__ + "img/2.6af39b7.png";